export default "__VITE_ASSET__BPrMFv$U__"